import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ProductDTO } from 'src/app/shared/models/dtos/responses/product-dto/product-dto';
import { RoutesKeys } from 'src/app/utils/routes';

@Component({
  templateUrl: './add-edit-reward.page.html',
})
/**
 * Component class for the Add/Edit Reward page.
 */
export class AddEditRewardPage {
  previousPage: RoutesKeys;
  product: ProductDTO | null = null;
  /**
   * @constructor
   */
  constructor(private router: Router) {
    const navigation = this.router.getCurrentNavigation();
    this.previousPage = navigation?.extras.state?.['previousPage'];
    this.product = navigation?.extras.state?.['product'] || null;
  }
}
